import { connect } from 'react-redux'
import { compose, withHandlers } from 'recompose'
import { resendLink } from './actions'
import { isResendInProgress, isLinkSent } from './selectors'
import View from '../../ui/email-verification/ResendToken'

const withResendStateAndActions = connect(
  state => ({
    isResending: isResendInProgress(state),
    isLinkSent: isLinkSent(state)
  }),
  {
    resendLink
  }
)

const withButtonHandler = withHandlers({
  onResendVerificationClick: props => e => {
    e && e.preventDefault()
    props.resendLink()
  }
})

export default compose(withResendStateAndActions, withButtonHandler)(View)



// WEBPACK FOOTER //
// ./src/services/email-verification/VerifyFail.js